import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { DataSharingService } from './services/data-sharing.service';
import { CommonDataService } from './services/common-data.service';
import { ContactUsService } from './services/contactus.service';
import { UserService } from './services/user.service';
import { PaymentService } from './services/payment.service';
import { StudentService } from './services/student.service';
import { InstructorService } from './services/instructor.service';
import { ClassScheduleService } from './services/class-schedule.service';
import { LoggerService } from './services/logger.service';
import { LocationService } from './services/location.service';
import { ClassMasterService } from './services/class-master.service';
import { AppRoutingModule } from './app-routing.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { TrainingProgramsComponent } from './training-programs/training-programs.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { HomeComponent } from './home/home.component';
import { NewStudentRegistrationComponent } from './new-student-registration/new-student-registration.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { RegisterProgressComponent } from './register-progress/register-progress.component';
import { SelectLocationComponent } from './select-location/select-location.component';
import { LocationCardComponent } from './location-card/location-card.component';
import { PaymentComponent } from './payment/payment.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { ClassHistoryLookupComponent } from './class-history-lookup/class-history-lookup.component';
import { PastStudentInfoComponent } from './past-student-info/past-student-info.component';
import { PastStudentRegisterProgressComponent } from './past-student-register-progress/past-student-register-progress.component';
import { SelectRequiredValidator } from './shared/select-required-validator.directive';
import { AutofocusDirective } from './shared/control-autofocus.directive';
import { StaffRegistrationComponent } from './staff-registration/staff-registration.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';
import { PaymentOnlineClassComponent } from './payment-online-class/payment-online-class.component';
import { RegisterOnlineProgressComponent } from './register-online-progress/register-online-progress.component';
import { PaymentConfirmationOnlineClassComponent } from './payment-confirmation-online-class/payment-confirmation-online-class.component';
import { MhsLoginComponent } from './login/mhs-login/mhs-login.component';
import { CreateLoginComponent } from './login/create-login/create-login.component';
import { CompareValidatorDirective } from './shared/compare-validators.directive';
import { ShowHidePasswordDirective } from './shared/show-hide-password.directive';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';

@NgModule({
   declarations: [
      AppComponent,
      AboutUsComponent,
      TrainingProgramsComponent,
      ContactUsComponent,
      HomeComponent,
      NewStudentRegistrationComponent,
      PageNotFoundComponent,
      RegisterProgressComponent,
      SelectLocationComponent,
      LocationCardComponent,
      PaymentComponent,
      PaymentConfirmationComponent,
      ClassHistoryLookupComponent,
      PastStudentInfoComponent,
      PastStudentRegisterProgressComponent,
      SelectRequiredValidator,
      AutofocusDirective,
      StaffRegistrationComponent,
      ForgotPasswordComponent,
      ConfirmPasswordComponent,
      PaymentOnlineClassComponent,
      RegisterOnlineProgressComponent,
      PaymentConfirmationOnlineClassComponent,
      MhsLoginComponent,
      CompareValidatorDirective,
      ShowHidePasswordDirective,
      RefundPolicyComponent,
CreateLoginComponent
   ],
   imports: [
      BrowserModule,
      FormsModule,
      HttpModule,
      AppRoutingModule,
      HttpClientModule
   ],
   providers: [
      AppService,
      DataSharingService,
      CommonDataService,
      StudentService,
      InstructorService,
      ClassScheduleService,
      ContactUsService,
      UserService,
      PaymentService,
      LocationService,
      ClassMasterService,
      LoggerService
   ],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts